import React from 'react'
import logo from '../Images/logo.png'

const Footer = () => {
  return (
    <>
      <footer>
        <div className='container'>
          <ul className='footer_list d-flex'>
            <li className='footer_list_item footer_list_item1 align-self'> <a href='https://timexscan.io/Contract/0x38843b9a1d2da12e953d356c356870c5b36746bb' target="_blank" className='footer_link josefin w'>Smart Contract info</a></li>
            <li className='footer_list_item footer_list_item2 align-self'> <a href='https://timexscan.io/alphawintransactions' className='footer_link josefin w' target="_blank">Alphawin Transactions</a></li>
            <li className='footer_list_item footer_list_item2 align-self'> <a href='https://timexscan.io/address/0xfd7f632415d8d4c2d36ede43dc4822f00619d1e3#tokentxns' target="_blank" className='footer_link josefin w'>Auto Pool info</a></li>
            <li className='footer_list_item footer_list_item5 align-self'> <a href='https://timexscan.io/Contract/0xf9e00165e31366367fc73c263ca1e7ac53a40520' target="_blank" className='footer_link josefin w'>USDT Contract info</a></li>
            <li className='footer_list_item footer_list_item4 align-self'> <a href='https://timexscan.io/address/0x0AD8b5648A8B02E694e1a6Af4cd9f633c529e766#tokentxns' target="_blank" className='footer_link josefin w'>Auto Pool Plan C</a></li>

          </ul>
          <div className="w-100 border-top pt-3 d-flex flex-column align-items-center text-center mt-3">

            <a href="/">
              <img className="logo mb-2" src={logo} alt="logo" />
            </a>

            <h6 className="footer_text inter w">
              © 2026 alphawin | All Rights Reserved.
            </h6>

          </div>
        </div>
      </footer>
    </>
  )
}

export default Footer


// https://bscscan.com/address/0x3BDa22B34c7672A1B94F433537A4Ed1d71F2ae14#tokentxns